import type { IconProps } from "./types";

export function CircleCheckBold({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM14.6084 6.33691C14.2421 6.00114 13.6728 6.02552 13.3369 6.3916L8.49902 11.668L6.66309 9.66504C6.32722 9.29864 5.75801 9.27353 5.3916 9.60938C5.02536 9.94527 5.00109 10.5145 5.33691 10.8809L7.83691 13.6084C8.00736 13.7942 8.24788 13.9004 8.5 13.9004C8.75212 13.9004 8.99265 13.7942 9.16309 13.6084L14.6631 7.6084C14.9988 7.2421 14.9745 6.67282 14.6084 6.33691Z"
        fill={currentColor}
        transform="translate(2 2)"
      />
    </svg>
  );
}
